import { render, staticRenderFns } from "./CampaignsComponent.vue?vue&type=template&id=345c0dce&scoped=true"
import script from "./CampaignsComponent.vue?vue&type=script&lang=js"
export * from "./CampaignsComponent.vue?vue&type=script&lang=js"
import style0 from "./CampaignsComponent.vue?vue&type=style&index=0&id=345c0dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c0dce",
  null
  
)

export default component.exports